import { Outlet } from "react-router-dom";
import PortalHeader from "./PortalHeader";
import Main from "../layout/Main";
import Footer from "../layout/Footer";
import { useLocation, useNavigate } from "react-router";
import { useContext, useEffect } from "react";
import PortalContext from "../../store/PortalContext";

const PortalLayout = ({ privateRoutePage }) => {
    const navigate = useNavigate();

    const portalCtx = useContext(PortalContext);

    // Use alternate header on Home page
    const location = useLocation();
    let isLogin = location.pathname.includes("login");

    useEffect(() => {
        //console.log(portalCtx)
        if (!portalCtx.id && !isLogin) {
            navigate("/portal/login");
        }
    }, [portalCtx, isLogin, navigate]);

    return (
        <>
            <div className="layout portalLayout">
                <PortalHeader />
                <Main className="portalbg">
                    <Outlet />
                </Main>
                <Footer />
            </div>
        </>
    );
};

export default PortalLayout;
